import { render, staticRenderFns } from "./ReportColumnLayoutEditor.vue?vue&type=template&id=0f63100c&scoped=true"
import script from "./ReportColumnLayoutEditor.vue?vue&type=script&lang=js"
export * from "./ReportColumnLayoutEditor.vue?vue&type=script&lang=js"
import style0 from "./ReportColumnLayoutEditor.vue?vue&type=style&index=0&id=0f63100c&prod&scoped=true&lang=css"
import style1 from "./ReportColumnLayoutEditor.vue?vue&type=style&index=1&id=0f63100c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f63100c",
  null
  
)

export default component.exports